<template>
  <v-container fluid class="indiamart-container pa-0 ma-0">
    <!-- Modern Header Section -->
    <div
      v-if="showHeader"
      class="header-section mb-6"
      style="margin: 0 12px; position: relative;"
    >
      <v-btn icon small class="header-close-btn" @click="dismissHeader">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
      <div class="d-flex align-center mb-4">
        <div class="header-icon-wrapper mr-4">
          <v-icon size="32" color="#FFFFFF">mdi-factory</v-icon>
        </div>
        <div>
          <h1 class="page-title mb-1">IndiaMart Integration</h1>
          <p class="page-subtitle mb-0">
            Connect your IndiaMart account and sync leads automatically
          </p>
        </div>
        <v-spacer></v-spacer>
        <div class="d-none d-sm-flex">
          <v-chip
            small
            class="mr-2"
            color="rgba(255,255,255,0.2)"
            text-color="white"
          >
            <v-icon small left>mdi-briefcase</v-icon>
            B2B Platform
          </v-chip>
        </div>
      </div>
      <v-row class="feature-pills ma-0">
        <v-col cols="6" sm="3" class="pa-1">
          <div class="feature-pill">
            <v-icon small class="mr-2" color="white">mdi-sync</v-icon>
            <span>Auto Sync</span>
          </div>
        </v-col>
        <v-col cols="6" sm="3" class="pa-1">
          <div class="feature-pill">
            <v-icon small class="mr-2" color="white">mdi-timer-sand</v-icon>
            <span>10 Min Updates</span>
          </div>
        </v-col>
        <v-col cols="6" sm="3" class="pa-1">
          <div class="feature-pill">
            <v-icon small class="mr-2" color="white">mdi-key</v-icon>
            <span>CRM Key</span>
          </div>
        </v-col>
        <v-col cols="6" sm="3" class="pa-1">
          <div class="feature-pill">
            <v-icon small class="mr-2" color="white"
              >mdi-format-list-bulleted</v-icon
            >
            <span>List Mapping</span>
          </div>
        </v-col>
      </v-row>
    </div>

    <!-- Content Section -->
    <div style="padding: 0 12px;">
      <v-card class="customBorderRadius" elevation="2">
        <v-row class="ma-0">
          <v-col cols="12" md="6" class="pa-6">
            <div class="text-center">
              <h2 class="text-h5 mb-4">Godial + IndiaMart</h2>

              <div class="text-left">
                <h3 class="text-h6 mb-3">How to use?</h3>
                <ol class="text-body-2" style="line-height: 1.8;">
                  <li class="mb-2">
                    Visit
                    <a
                      href="https://seller.indiamart.com"
                      target="_blank"
                      class="primary--text"
                      >seller.indiamart.com</a
                    >, login to your account
                  </li>
                  <li class="mb-2">
                    Settings > Account Settings available on the left navigation
                  </li>
                  <li class="mb-2">
                    Now click on Generate Key. A unique CRM key will be received
                    on your registered email-id
                  </li>
                  <li class="mb-2">
                    Copy the key and your phone into the form and choose your
                    list where you want to get your leads
                  </li>
                  <li class="mb-2">
                    Save and we will auto sync your leads every 10 mins
                  </li>
                </ol>
                <p class="text-body-2 mt-4">
                  For more details visit:
                  <a
                    target="_blank"
                    href="https://help.indiamart.com/knowledge-base/lms-crm-integration/"
                    class="primary--text"
                  >
                    this link
                  </a>
                </p>
                <p class="text-caption mt-4">
                  Feel free to reach out to us at
                  <a href="mailto:support@godial.cc" class="primary--text"
                    >support@godial.cc</a
                  >
                  if you are interested in these features
                </p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="pa-6">
            <div class="d-flex flex-column">
              <h3 class="text-h6 mb-4 text-center">Enable IndiaMart</h3>
              <div class="d-flex justify-center">
                <v-switch
                  v-model="indiamart.enabled"
                  color="success"
                  :label="indiamart.enabled ? 'Enabled' : 'Disabled'"
                ></v-switch>
              </div>

              <h3 class="text-h6 mb-4 mt-4 text-center">
                IndiaMart Credentials
              </h3>

              <v-text-field
                v-model="indiamart.config.GLUSR_MOBILE"
                :disabled="!indiamart.enabled"
                label="Mobile Number"
                type="number"
                outlined
                dense
                class="customBorderRadius"
                prepend-inner-icon="stay_primary_portrait"
              ></v-text-field>

              <v-text-field
                v-model="indiamart.config.GLUSR_MOBILE_KEY"
                :disabled="!indiamart.enabled"
                label="Mobile Key"
                type="text"
                outlined
                dense
                class="customBorderRadius"
                prepend-inner-icon="vpn_key"
              ></v-text-field>

              <v-autocomplete
                v-model="indiamart.listId"
                :disabled="!indiamart.enabled"
                class="pt-1 customBorderRadius"
                :items="lists"
                item-text="name"
                item-value="id"
                label="Lists"
                prepend-inner-icon="view_list"
                autocomplete="false"
                outlined
                dense
              />

              <v-btn
                color="primarygrad"
                dark
                block
                class="customBorderRadius mt-4"
                @click="setIndiamart"
              >
                Save
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </div>

    <!-- Loader -->
    <v-dialog v-model="loader" persistent width="300">
      <v-card color="primary white--text" dark>
        <v-card-text style="padding: 18px 25px">
          <h3 style="margin-bottom: 5px; font-weight: 400; font-size: 16px">
            Please Wait...
          </h3>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import fb from "../../js/firebase";

export default {
  data() {
    return {
      showHeader: false,
      indiamart: {
        type: "indiamart",
        config: {
          GLUSR_MOBILE: "",
          GLUSR_MOBILE_KEY: "",
        },
        listId: "",
        companyId: "",
        enabled: false,
      },
      loader: false,
      lists: [],
    };
  },

  computed: {
    ...mapGetters(["ENDPOINT", "companyDetails", "selectedTeam"]),
  },
  watch: {},
  created() {
    this.showHeader =
      localStorage.getItem("indiamartHeaderDismissed") !== "true";
    this.fetchLists();
    this.getIndiaMartDetails();
    this.indiamart.companyId = this.companyDetails.id;
  },
  methods: {
    dismissHeader() {
      this.showHeader = false;
      localStorage.setItem("indiamartHeaderDismissed", "true");
    },
    async getIndiaMartDetails() {
      var resp = await this.$http.get(
        `${this.ENDPOINT}/integrations?filter[where][companyId]=${this.companyDetails.id}&filter[where][type]=indiamart`,
      );

      if (resp.body.length > 0) this.indiamart = resp.body[0];
    },
    getTeamIds() {
      var teams = [];
      if (this.selectedTeam == "allTeams") {
        teams = _.map(this.teams, "id");
      } else {
        teams.push(this.selectedTeam);
      }

      teams = _.without(teams, "allTeams");

      return teams;
    },
    async fetchLists() {
      try {
        this.lists = [];
        var response = [];

        var teamIds = this.getTeamIds();

        // Teams sections
        response = await this.$http.post(`${this.ENDPOINT}/lists/fetch`, {
          teams: teamIds,
        });
        this.lists = response.body;

        if (this.lists.length < 1) {
          this.loader = false;
          return;
        }
      } catch (e) {
        this.loader = false;
        console.log("error in list fetch", e);
      }
    },

    async setIndiamart() {
      if (this.indiamart.config.GLUSR_MOBILE == "") {
        return this.$swal({
          type: "warning",
          text: "Mobile Number Can't be Blank",
        });
      }

      if (this.indiamart.config.GLUSR_MOBILE_KEY == "") {
        return this.$swal({
          type: "warning",
          text: "Mobile Key Can't be Blank",
        });
      }

      this.loader = true;

      try {
        this.indiamart.companyId = this.companyDetails.id;
        this.indiamart.type = "indiamart";
        var res = {};
        //If new user
        if (typeof this.indiamart.id == "undefined") {
          // Add Indiamart Details In Company Data
          res = await this.$http.post(
            `${this.ENDPOINT}/integrations`,
            this.indiamart,
          );
        } else {
          res = await this.$http.put(
            `${this.ENDPOINT}/integrations/${this.indiamart.id}`,
            this.indiamart,
          );
        }

        // Success Message
        if (res.status == 200) {
          // Set Company Object for Store dispatch
          this.getIndiaMartDetails();
          this.loader = false;

          try {
            fb.log("indiamart_added");
          } catch (e) {
            console.log("Error in FB log", e);
          }

          return this.$swal({
            type: "success",
            text: "Indiamart Added to Godial Successfully",
          });
        } else {
          return this.$swal({
            type: "warning",
            text: "Something Went Wrong",
          });
        }
      } catch (err) {
        console.log(err);
        this.loader = false;
        return this.$swal({
          type: "warning",
          text: err.body.error.message,
        });
      }
    },
  },
};
</script>

<style scoped>
.indiamart-container {
  background-color: var(--v-background-base, #f5f5f5);
  min-height: 100vh;
}

.theme--dark .indiamart-container {
  background-color: #121212 !important;
}
</style>
